import axios from 'axios';

const state = () => ({
    list : [],
    order_id : "",
    loaded : false,
    error : false,
    errorMessage : null,
    allLoaded : false,
    columns: {
      KRKT: [
        {
            key : "bundleno",
            label : "bundleno",
            display : true
        },
        {
            key : "quality",
            label: "quality",
            display:true,
        },
        {
            key : "quantity",
            label: "quantity",
            display:true,
        },
        {
            key : "dimensionActual",
            label: "dimensionActual",
            display:true,
        },
        {
            key : "volumeActual",
            label: "volumeActual",
            type: "decimal",
            digits: 3,
            display:true,
        },
        {
            key : "dimensionNominal",
            label: "dimensionNominal",
            display:true,
        },
        {
            key : "volumeNominal",
            label: "volumeNominal",
            type: "decimal",
            digits: 3,
            display:true,
        },
        {
          key : "buyingpriceTotalActual",
          label: "buyingpriceTotalActual",
          type: "decimal",
          digits: 2,
          display : true
        },
        {
            key : "buyingpriceTotalNominal",
            label: "buyingpriceTotalNominal",
            type: "decimal",
            digits: 2,
            display : true
        },
        {
          key : "sellingpriceTotalActual",
          label: "sellingpriceTotalActual",
          type: "decimal",
          digits: 2,
          display : true
        },
        {
            key : "sellingpriceTotalNominal",
            label: "sellingpriceTotalNominal",
            type: "decimal",
            digits: 2,
            display : true
        },
      ],
         'M&G' : [
        {
            key : "bundleno",
            label : "bundleno",
            display : true
        },
        {
            key : "quality",
            label: "quality",
            display:true,
        },
        {
            key : "quantity",
            label: "quantity",
            display:true,
        },
        {
            key : "dimensionActual",
            label: "dimensionActual",
            display:true,
        },
        {
            key : "volumeActual",
            label: "volumeActual",
            type: "decimal",
            digits: 3,
            display:true,
        },
        {
          key : "buyingpriceTotalActual",
          label: "buyingpriceTotalActual",
          type: "decimal",
          digits: 2,
          display : true
        },
        {
          key : "sellingpriceTotalActual",
          label: "sellingpriceTotalActual",
          type: "decimal",
          digits: 2,
          display : true
        }
      ],
    },
    workingOn: [],
})

  // getters
  const getters = {
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){

      commit("loaded", false);
      await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/external/shinkiba/order/" + rootState.kooi.kooi.data.order_id).then((response) => {
        if (!response.data.data.result) {
          commit("error", true);
          commit("errorMessage", response.data.data.message);
        } else {
          commit("set", response.data.data.data);
        }

        commit("loaded", true);
      }).catch(error => {
          commit("error", true);
          commit("errorMessage", 'unkown error');
      })
    },
  }

  // mutations
  const mutations = {
      set(state, data){
        state.list = data;
      },
      loaded(state, status){
          state.loaded = status;
      },
      order_id(state, order){
          state.order_id = order;
          state.loaded = false;
          state.error = false;
          state.list = [];
      },
      error(state, status){
          state.error = status;
      },
      errorMessage(state, message) {
        state.errorMessage = message;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
